import { TextField, InputAdornment, Stack, Typography, FormHelperText } from "@mui/material";
import { Controller } from "react-hook-form";
import usePostalCodeSearch from '../utils/usePostalCodeSearch';
const InputFieldAddress = ({
  control,
  errors,
  setValue,
  isEditMode = true,
  size = 'small',
  label,
}) => {

  const { handlePostalCodeChange } = usePostalCodeSearch(setValue);

  return (
    <>
      <Stack direction="row" gap={1} flexWrap="wrap">
        {/* 郵便番号 */}
        <Controller
          name="postal_code"
          control={control}
          rules={{
            required: '※郵便番号は必須です',
            pattern: {
              value: /^[0-9]{7}$/,
              message: '※郵便番号は7桁の数字で入力してください'
            }
          }}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              label={label}
              placeholder="0000000"
              sx={{ minWidth: '130px', width: '150px' }}
              size={size}
              disabled={!isEditMode}
              error={!!fieldState.error}
              inputProps={{
                maxLength: 7,
                inputMode: 'numeric'
              }}
              onChange={(e) => {
                // 数字以外を除去（全角→半角も対応可）
                const value = e.target.value.replace(/[０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 0xFEE0))
                  .replace(/\D/g, '');

                field.onChange(value);
                handlePostalCodeChange?.({
                  ...e,
                  target: {
                    ...e.target,
                    value
                  }
                });
              }}
              InputProps={{
                startAdornment: <InputAdornment position="start">〒</InputAdornment>
              }}
            />
          )}
        />

        {/* 都道府県 */}
        <Controller
          name="state"
          control={control}
          rules={{
            required: '都道府県は必須です',
            maxLength: {
              value: 50,
              message: '※都道府県は50文字以内で入力してください'
            }
          }}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              placeholder="都道府県"
              sx={{ flex: 1 }}
              size={size}
              disabled={!isEditMode}
              error={!!fieldState.error}
              inputProps={{ maxLength: 50 }}
            />
          )}
        />

      </Stack>
      {/* 住所 */}
      <Controller
        name="address_line"
        control={control}
        rules={{
          required: '住所は必須です',
          maxLength: {
            value: 255,
            message: '※住所は255文字以内で入力してください'
          }
        }}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            placeholder="以降の住所を入力"
            size={size}
            disabled={!isEditMode}
            sx={{ mt: 1 }}
            multiline
            error={!!fieldState.error}
            inputProps={{ maxLength: 255 }}
          />
        )}
      />

      {(errors?.postal_code?.message || errors?.state?.message || errors?.address_line?.message) && (
        <FormHelperText error>
          {errors?.postal_code?.message || errors?.state?.message || errors?.address_line?.message}
        </FormHelperText>
      )}
    </>
  );
};

export default InputFieldAddress;
